import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

import Icon from '@/elements/Icon';
import styled from '@/styles';

const Wrapper = styled('div', {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '1rem',
  padding: '1rem',
  marginBottom: '1rem',
  border: '1px solid $colors$dangerLight',
  borderRadius: '$lg',
  backgroundColor: '$colors$dangerLightest',
  color: '$colors$dangerDarker',
});

const ConflictLink = styled(Link, {
  color: 'inherit',
  fontWeight: 600,
  textDecoration: 'underline',
});

export type ConflictingWorker = { id: number; name: string } | null;

type Props = {
  message: string;
  conflictingWorker: ConflictingWorker;
};

const EmailTakenAlert = ({ message, conflictingWorker }: Props) => {
  if (!conflictingWorker) {
    return (
      <Wrapper data-testid="email-taken-alert">
        <Icon fixedWidth icon={faExclamationTriangle} />
        <div>{message}</div>
      </Wrapper>
    );
  }

  return (
    <Wrapper data-testid="email-taken-alert">
      <Icon fixedWidth icon={faExclamationTriangle} />
      <div>
        Email already used by{' '}
        <ConflictLink
          to={`/workers_v2/${conflictingWorker.id}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {conflictingWorker.name}
        </ConflictLink>
      </div>
    </Wrapper>
  );
};

export default EmailTakenAlert;
